export interface CustomerSearchResponse {
  contacts: CustomerResponse[]
}

export type PaginationType = {
  page: number
  pageSize: number
}

export interface CustomerResponse {
  id: string
  contact_id: string
  name: string
  default_tds: number
  possible_tds: number[]
}

export class Customer {
  id: string
  contactId: string
  name: string
  defaultTds: number
  possibleTds: number[]
  constructor(customerResponse?: CustomerResponse) {
    this.id = customerResponse?.id ?? ""
    this.contactId = customerResponse?.contact_id ?? ""
    this.name = customerResponse?.name ?? ""
    this.defaultTds = customerResponse?.default_tds ?? 0
    this.possibleTds = customerResponse?.possible_tds ?? []
  }
}

export interface CustomerListResponse {
  contacts: ListCustomerResponse[]
  totalRowCount?: number
}

type ListCustomerResponse = {
  customer_id: string
  company: string
  name: string
  email: string
  pan_no: string
  centre_name: string
  centre_code: string
  is_escrow_account_payments: boolean
  is_international_payments: boolean
  status: string
  source: string
  has_deducted_tds: boolean
  code: string
  tds: number
}

export class ListCustomer {
  customerId: string
  company: string
  name: string
  email: string
  panNo: string
  centreName: string
  centreCode: string
  isEscrowAccountPayments: boolean
  isInternationalPayments: boolean
  status: string
  source: string
  hasDeductedTds: boolean
  code: string
  tds: number

  constructor(customerResponse: ListCustomerResponse) {
    this.customerId = customerResponse.customer_id ?? ""
    this.company = customerResponse.company ?? ""
    this.name = customerResponse.name ?? ""
    this.email = customerResponse.email ?? ""
    this.panNo = customerResponse.pan_no ?? ""
    this.centreName = customerResponse.centre_name ?? ""
    this.centreCode = customerResponse.centre_code ?? ""
    this.isEscrowAccountPayments =
      customerResponse.is_escrow_account_payments ?? false
    this.isInternationalPayments =
      customerResponse.is_international_payments ?? false
    this.status = customerResponse.status ?? ""
    this.source = customerResponse.source ?? ""
    this.hasDeductedTds = customerResponse.has_deducted_tds ?? false
    this.code = customerResponse.code ?? ""
    this.tds = customerResponse.tds ?? 0
  }
}

type CustomerRepositoryResponse = {
  name: string
  customer_id: string
  company: string
  email: string
  pan_no: string
  source: string
  centre_code: string
  status: string
  seats: number
  reference_no: string
  description: string
  payee: string
}

export interface CustomerRepositoryListResponse {
  contacts: CustomerRepositoryResponse[]
  totalRowCount?: number
}

export class CustomerRepository {
  customerId: string
  name: string
  company: string
  email: string
  panNo: string
  source: string
  centreCode: string
  status: string
  seats: number
  referenceNo: string
  description: string
  payee: string

  constructor(customerResponse: CustomerRepositoryResponse) {
    this.customerId = customerResponse.customer_id ?? ""
    this.name = customerResponse.name ?? ""
    this.company = customerResponse.company ?? ""
    this.email = customerResponse.email ?? ""
    this.panNo = customerResponse.pan_no ?? ""
    this.source = customerResponse.source ?? ""
    this.centreCode = customerResponse.centre_code ?? ""
    this.status = customerResponse.status ?? ""
    this.seats = customerResponse.seats ?? 0
    this.referenceNo = customerResponse.reference_no ?? ""
    this.description = customerResponse.description ?? ""
    this.payee = customerResponse.payee ?? ""
  }
}
